import { render, staticRenderFns } from "./TablePaginatedSalaryBase.vue?vue&type=template&id=2a08919c&scoped=true"
import script from "./TablePaginatedSalaryBase.vue?vue&type=script&lang=js"
export * from "./TablePaginatedSalaryBase.vue?vue&type=script&lang=js"
import style0 from "./TablePaginatedSalaryBase.vue?vue&type=style&index=0&id=2a08919c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a08919c",
  null
  
)

export default component.exports